export default "__VITE_ASSET__$ydPhX4U__"